// Swaps "Chatwoot" in every locale string for the installation name, so the
// rebrand applies to all languages without touching Crowdin-managed files.
// \b keeps placeholders like {latestChatwootVersion} intact.
export const brandLocaleMessages = messages => {
  const name = window.globalConfig?.INSTALLATION_NAME;
  if (!name || name === 'Chatwoot') return messages;

  const escapedName = JSON.stringify(name).slice(1, -1);
  return JSON.parse(
    JSON.stringify(messages).replace(/\bChatwoot\b/g, () => escapedName)
  );
};
